var _defs, _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo192(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.55 24.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.63,24.18h-.97c-1.69,0-2.94-.39-3.76-1.18-.82-.79-1.23-1.98-1.23-3.57v-4.48c0-.42-.05-.8-.14-1.14-.1-.33-.26-.62-.5-.85-.24-.23-.56-.41-.96-.53-.4-.12-.9-.18-1.5-.18H0v-1.81H.56c.64,0,1.16-.05,1.56-.16,.4-.1,.72-.26,.94-.48,.23-.21,.38-.48,.47-.81,.09-.33,.13-.72,.13-1.17v-3.08c0-.73,.09-1.39,.26-1.97,.17-.59,.46-1.08,.86-1.5,.4-.41,.91-.73,1.55-.95,.63-.22,1.41-.33,2.33-.33h.97V1.82h-.77c-2.03,0-3.04,.98-3.04,2.93v3.03c0,2.12-.92,3.31-2.76,3.58,1.86,.18,2.79,1.37,2.79,3.57v4.45c0,1.99,1,2.98,3.01,2.98h.77v1.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.92,0h.97c1.69,0,2.94,.39,3.76,1.18,.82,.79,1.23,1.98,1.23,3.57v4.48c0,.42,.05,.8,.14,1.14,.1,.33,.26,.62,.5,.85,.24,.23,.56,.41,.96,.53,.4,.12,.9,.18,1.5,.18h.56v1.81h-.56c-.64,0-1.16,.05-1.56,.16-.4,.1-.72,.26-.94,.48-.23,.21-.38,.48-.47,.81-.09,.33-.13,.72-.13,1.17v3.08c0,.73-.09,1.39-.26,1.97-.17,.59-.46,1.08-.86,1.5-.4,.41-.91,.73-1.55,.95-.63,.22-1.41,.33-2.33,.33h-.97v-1.82h.77c2.03,0,3.04-.98,3.04-2.93v-3.03c0-2.12,.92-3.31,2.76-3.58-1.86-.18-2.79-1.37-2.79-3.57V4.8c0-1.99-1-2.98-3.01-2.98h-.77V0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.89,
    y: 6.75,
    width: 10.76,
    height: 10.69,
    rx: 1.14,
    ry: 1.14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo192);
export default __webpack_public_path__ + "static/media/logo192.77cb01e5e02474b954ad65819a1c1a64.svg";
export { ForwardRef as ReactComponent };